'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../../components');

var _clearNumber = require('../../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _beautifyNumber = require('../../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _paymentCalculation = require('../../../helpers/paymentCalculation');
var _packagesData = require('../../../packagesData');

var _PackageItem = require('../PackageItem.scss');var styles = _interopRequireWildcard(_PackageItem);
var _packagesConfigs = require('../../../containers/RealtorPackagesContainer/packagesConfigs');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// Styles
var

RealtorPackageDetails = function (_Component) {_inherits(RealtorPackageDetails, _Component);function RealtorPackageDetails() {var _temp, _this, _ret;_classCallCheck(this, RealtorPackageDetails);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      periods: (0, _packagesData.getPackagePeriods)(true) }, _this.








    defineMonthTitle = function (quantity) {return quantity === 12 ? 'yearly' : 'monthly';}, _this.

    renderPromoIcon = function (promotion) {
      switch (promotion) {
        case _packagesConfigs.PROMOTIONS.TOP_AD:return _react2.default.createElement(_components.OMLabelTop, { label: 'TOP', title: 'TOP' });
        case _packagesConfigs.PROMOTIONS.HIGHLIGHTS:return (
            _react2.default.createElement('span', { className: 'icon icon-promoted-active' },
              _react2.default.createElement('i', { className: 'path1' }),
              _react2.default.createElement('i', { className: 'path2' }),
              _react2.default.createElement('i', { className: 'path3' })));


        case _packagesConfigs.PROMOTIONS.AUTO_JUMPS:return (
            _react2.default.createElement('span', { className: 'icon icon-auto-jump-active' },
              _react2.default.createElement('i', { className: 'path1' }),
              _react2.default.createElement('i', { className: 'path2' }),
              _react2.default.createElement('i', { className: 'path3' })));


        default:return '';}

    }, _this.

    renderOnePropertyPriceTitle = function (selectedPeriod) {
      var price = (0, _get2.default)(_this.props, 'packageData.period[' + selectedPeriod + '].price');
      var beautifiedPrice = (0, _beautifyNumber2.default)((0, _clearNumber2.default)(price));
      return _react2.default.createElement('span', { className: styles.priceTitle }, '\u20AA' + beautifiedPrice, ' ', _react2.default.createElement('span', null, _this.props.translate('perMonth')));
    }, _this.

    renderPeriodSelection = function (selectedPeriod) {return (
        _react2.default.createElement('div', { className: styles.period },
          _react2.default.createElement(_components.OMSegmentedControl, {
            name: 'period',
            className: 'rounded',
            theme: 'gray',
            selectedValue: selectedPeriod,
            values: _this.state.periods.map(function (item) {return {
                value: item,
                label: '' + _this.props.translate(_this.defineMonthTitle(item)) };}),

            onChange: function onChange(period) {return _this.props.changeSelectedPayment({ period: period });} }),

          _react2.default.createElement('span', { className: styles.monthPayment }, _this.renderOnePropertyPriceTitle(selectedPeriod))));}, _this.



    renderFeature = function (feature) {var _cx;var _this$props =
      _this.props,translate = _this$props.translate,packageData = _this$props.packageData,selectedPackage = _this$props.selectedPackage;
      var selectedPeriod = selectedPackage.period;

      var featuresData = (0, _get2.default)(packageData, 'period[' + selectedPeriod + ']', {});

      var value = featuresData[feature];
      var status = !!value ? 'check' : 'close2';
      var title = translate('promo_' + feature);
      var xCount = !!value && typeof value === 'number' ? 'x ' + value : '';
      var duration = feature === _packagesConfigs.PROMOTIONS.TOP_AD && !!xCount ? translate('forOneMonth') : '';
      var directionMark = _this.props.isRtl ? '\u200F' : '';

      var promotionIcon = !!xCount ? _this.renderPromoIcon(feature) : '';

      return (
        _react2.default.createElement('div', {
            key: packageData.id + '_' + feature,
            className: (0, _classnames2.default)(styles.featureItem, (_cx = {}, _cx[styles.disabledFeature] = !value, _cx)) },

          _react2.default.createElement('span', { className: 'icon icon-' + status }),
          feature === _packagesConfigs.PROMOTIONS.PROPERTIES ?
          _react2.default.createElement('span', null, value, ' ', title) :

          _react2.default.createElement('span', null, title, '\xA0',
            _react2.default.createElement('span', { className: styles.bold },
              directionMark, xCount), '\xA0',
            duration),



          _react2.default.createElement('span', { className: styles.promoIcon }, '\xA0', promotionIcon)));


    }, _temp), _possibleConstructorReturn(_this, _ret);}RealtorPackageDetails.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {var periodIsChanged = nextProps.selectedPackage.period !== this.props.selectedPackage.period;var localeIsChanged = nextProps.locale !== this.props.locale;return periodIsChanged || localeIsChanged;};RealtorPackageDetails.prototype.

  render = function render() {
    var selectedPeriod = this.props.selectedPackage.period;

    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { className: styles.packageFeatures }, _packagesConfigs.PACKAGE_FEATURES_ORDER.map(this.renderFeature)),
        this.renderPeriodSelection(selectedPeriod)));


  };return RealtorPackageDetails;}(_react.Component);


RealtorPackageDetails.propTypes = {
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  packageData: _propTypes2.default.object,
  selectedPackage: _propTypes2.default.object,
  changeSelectedPayment: _propTypes2.default.func };exports.default =


RealtorPackageDetails;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PackageItem/Details/RealtorPackageDetails.js
// module id = 2784
// module chunks = 0